import { ChainId } from '@pancakeswap-libs/sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x8b8141Db2a8168f8F3aDF01e8345dEB7B4dD63B8', // TODO
  [ChainId.BSCTESTNET]: '0x086B73F33bb1a96Ea463328F6412ce3b5730FbE9'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
